import { apiClient } from "../../../../lib/api-client";
import { useMutation } from '@tanstack/react-query';
import { ChangePasswordResult } from "../types/ChangePasswordResult";

export const useUpdateMyAccountInformationMutation = () => useMutation({
    mutationFn: async (information: FormData) => {
        try {
            let data: ChangePasswordResult = await apiClient.post("my-account/information", information, { headers: { "Content-Type": "multipart/form-data" }, });

            return {
                isOk: data.isSuccess,
                message: data.errorMessage
            };
        } catch {
            return {
                isOk: false,
                message: "Failed to update account information"
            };
        }
    },
})

